module.exports = __webpack_public_path__ + "media/images/new_landing/case/case-emco-556cf33c3bdd13657cc977493f6ce61c.jpg";